// import BMIGauge from "./BMIGauge";
import HealthGauge from "./HealthGauge";
import styles from "./PatientCard.module.css";

export default function PatientCard({ patient, size = 110 }) {

  const patientInfo = JSON.parse(
    localStorage.getItem("patientPersona") || "{}"
  );

  const data = {
    name: patientInfo.name || patient.name,
    age: patientInfo.age || patient.age,
    mobile: patientInfo.mobile || patient.mobile,
    heightCm: patientInfo.heightCm || patient.height,
    weightKg: patientInfo.weight || patient.weight,
    profession: patientInfo.profession || "",
    maritalStatus: patientInfo.maritalStatus || "",
  };

  const initials = data.name
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();



  const bmi =
  data.weightKg && data.heightCm
    ? Number(data.weightKg) / Math.pow(Number(data.heightCm) / 100, 2)
    : null;

  const getColor = (bmi) => {
    if (bmi < 18.5) return "#f59e0b";
    if (bmi < 25) return "#22c55e";
    if (bmi < 30) return "#f59e0b";
    return "#ef4444";
  };

  const angle = bmi ? Math.min((bmi / 40) * 180, 180) : 0;
  const color = bmi ? getColor(bmi) : "#ccc";

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        {/* Left */}
        <div className={styles.header}>
          <div className={styles.avatar}>{initials}</div>
          <div>
            <p className={styles.name}>{data.name}</p>
            <p className={styles.meta}> Female · {data.age} yrs</p>
            <p className={styles.mobile}>+91 {data.mobile ? data.mobile : " "}</p>
            <p  className={styles.mobile}>{ data?.weight}</p>
          </div>
        </div>

        {/* Right */}
        {bmi && (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    <HealthGauge value={Number(bmi.toFixed(1))} size={size} />
  </div>
)}
            {/* <div className={styles.gaugeWrap}>
        <div className={styles.gauge}>
          <div className={styles.gaugeBg}></div>

          <div
            className={styles.needle}
            style={{
              transform: `rotate(${angle - 90}deg)`,
              background: color,
            }}
          />

          <div className={styles.center}></div>
        </div>

        <p className={styles.bmi}>{bmi}</p>
      </div> */}
          {/* </> */}

        {/* )} */}
      </div>
    </div>
  );
}